import React, { Component } from 'react';
import { Table, Glyphicon } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../../content/css/PortfolioAnalysis/PortfolioAnalysisDocumentsTable.css';

export default class DocumentsTable extends Component {
    constructor(props) {
        super(props);
    }

    getContractTypeName = (type) => {
        switch (type) {
            case 0: return "Procurement agreement";
            case 1: return "Customer agreement";
            case 2: return "Unknown";
            case 3: return "NDA - receiving information";
            case 4: return "NDA - giving information";
            case 5: return "NDA - giving/receiving information";
            case 6: return "EULA - Customer";
            case 7: return "Terms & conditions";//"EULA - Seller";
            case 8: return "Distribution agreement - Customer";
            case 9: return "Distribution agreement - Seller";
            case 10: return "DPA - Controller";
            case 11: return "DPA - Processor";
            case 12: return "License agreement - Customer";
            case 13: return "License agreement - Seller";
            case 14: return "Source of Goods agreement";
        }
    }

    ticksToDateString = (ticks) => {
        const ticksPerMillisecond = 10000;
        const epochTicks = 621355968000000000; // number of ticks between .NET epoch (January 1, 0001) and Unix epoch (January 1, 1970)
        let javascriptTimestamp = (ticks - epochTicks) / ticksPerMillisecond;
        let date = new Date(javascriptTimestamp);
        return date.toLocaleDateString();
    }

    renderItems = () => {
        if (this.props.items == null)
            return [];

        let extraColumnData = [];
        if (this.props.extraColumnData != null) {
            extraColumnData = this.props.extraColumnData.map(x => x === "0" ? "Missing" : x);
        }

        let getHighlightIndex = (highlight) => highlight.highlightIndex && !isNaN(highlight.highlightIndex) ? highlight.highlightIndex + 1 : 1;

        return this.props.items.map((x, index) =>
            <tr>
                <td><Link to={`${this.props.basePathForLinks}/${this.props.reportId}/document/${x.id}/viewer/${getHighlightIndex(x)}`}>{x.filename.slice(0, 50)}</Link></td>
                {!this.props.hideContractType &&
                    <td>{this.getContractTypeName(x.contractType)}</td>
                }
                {this.props.showBreaches &&
                    <td>{x.breachesCount + x.missingCount}</td>
                }
                {this.props.extraColumnTitle && this.props.extraColumnData &&
                    <td>{extraColumnData[index]}</td>
                }
                <td>{this.ticksToDateString(x.wasSaved)}</td>
                {/*<td><Glyphicon glyph="option-horizontal" /></td>*/}
            </tr>
        );
    }

    render() {
        return (
            <Table className="documents-table" hover>
                <thead>
                    <tr>
                        <th>Filename</th>
                        {!this.props.hideContractType &&
                            <th>Contract type</th>
                        }
                        {this.props.showBreaches &&
                            <th># of breaches</th>
                        }
                        {this.props.extraColumnTitle &&
                            <th>{this.props.extraColumnTitle}</th>
                        }
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderItems()}
                </tbody>
            </Table>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/AnalysisReports/DocumentsTable.js